module.exports = __webpack_public_path__ + "assets/img/pic3.622f50b6.png";